import React from 'react';
import {
  Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectTrigger, SelectValue,
} from '../../components/ui/select';
import { groupRuns } from './pickSelectGroups';

const LABEL_CLS = 'text-[11px] font-semibold uppercase tracking-wider text-slate-500';
const EMPTY = '__empty__'; // Radix does not allow an item with value ""
const item = (o) => <SelectItem key={o.value || EMPTY} value={o.value || EMPTY}>{o.label}</SelectItem>;

// Custom dropdown for a list of options; replaces the native <select>.
// `options` = [{ value, label }]. An option with value "" is a real choice
// (e.g. "Unincorporated"); `placeholder` shows when nothing is picked.
// An option with `group` is listed under that heading (consecutive runs, in order).
export default function PickSelect({ label, value, onChange, options, placeholder, testId, labelClassName = LABEL_CLS }) {
  const hasEmpty = options.some((o) => o.value === '');
  const current = value || (hasEmpty ? EMPTY : '');
  return (
    <div>
      {label && <div className={labelClassName}>{label}</div>}
      <Select value={current} onValueChange={(v) => onChange(v === EMPTY ? '' : v)}>
        <SelectTrigger className={label ? 'mt-1' : ''} data-testid={testId} aria-label={label}>
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent className="max-h-64">
          {groupRuns(options).map((run, i) => (run.group ? (
            <SelectGroup key={`${run.group}-${i}`}>
              <SelectLabel>{run.group}</SelectLabel>
              {run.items.map(item)}
            </SelectGroup>
          ) : run.items.map(item)))}
        </SelectContent>
      </Select>
    </div>
  );
}
